<template>
  <div class="b-full-table__row">
    <div class="b-full-table__cell b-full-table__cell-name" @click="editAlternativeContractById(currentContract.idInDb)">
      {{currentContract.number}}
    </div>
    <div class="b-full-table__cell">{{currentContract.date | dateFormatted}}</div>
    <div class="b-full-table__cell">{{getLesseeName(currentContract.lesseeId)}}</div>
    <div class="b-full-table__cell">
      <div class="mb-2" v-for="item in lessors">{{item}}</div>
    </div>
    <div class="b-full-table__cell">
      <div class="mb-2" v-if="currentContract.isLowValue">{{$t('CONTENT.contract.is_low_value')}}</div>
      <div class="mb-2" v-if="currentContract.isExceptionToArticle3OfIFRS16">{{$t('CONTENT.contract.isExceptionToArticle3OfIFRS16')}}</div>
      <div class="mb-2" v-if="currentContract.isIrrelevant">{{$t('CONTENT.contract.isIrrelevant')}}</div>
      <div class="mb-2" v-if="currentContract.isNotRentContract">{{$t('CONTENT.contract.isNotRentContract')}}</div>
      <div class="mb-2" v-if="currentContract.isShortTerm">{{$t('CONTENT.contract.isShortTerm')}}</div>
      <div class="mb-2" v-if="currentContract.isVariableLeasePayments">{{$t('CONTENT.contract.isVariableLeasePayments')}}</div>
    </div>
	<div class="b-full-table__cell">
		{{currentContract.prolongationType}}
	</div>
    <div class="b-full-table__cell">{{currentContract.responsible}}</div>
  </div>
</template>

<script>
import dateConverter from "../../../utils/converters/date.converter";
import {mapGetters} from 'vuex';

export default {
  props: {
    currentContract: {
      type: Object,
    }
  },
  data() {
    return {
      show: false
    }
  },
  computed: {
    ...mapGetters(['allCounterparties']),
    lessors() {
      let lessors = [];
      for (let i = 0; i < this.allCounterparties.length; i++) {
        for (let j = 0; j < this.currentContract.lessorIds.length; j++) {
          if (this.allCounterparties[i].idInDB === this.currentContract.lessorIds[j]) {
            lessors.push(this.allCounterparties[i].displayName);
          }
        }
      }
      return lessors;
    }
  },
  methods: {
    getLesseeName(lesseeId) {
      for (let i = 0; i < this.allCounterparties.length; i++) {
        if(this.allCounterparties[i].idInDB === lesseeId) {
          return this.allCounterparties[i].displayName;
        }
      }
    },
    editAlternativeContractById(id) {
      this.$router.push({ name: 'AlternativeContractEdit', params: {id}})
    }
  }
}
</script>
